import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Mail, ArrowLeft, MailCheck } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { formatApiError } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Errore");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16" data-testid="forgot-password-page">
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="font-heading text-2xl font-semibold tracking-tight">
            auto<span className="text-[#0055FF]">.</span>advisor
          </Link>
          <h1 className="mt-6 font-heading text-3xl font-semibold tracking-tight">
            {done ? "Controlla la tua email" : "Password dimenticata?"}
          </h1>
          <p className="mt-2 text-sm text-[#666]">
            {done
              ? "Se l'email è registrata, riceverai un link per reimpostare la password. Il link è valido per 30 minuti."
              : "Inserisci l'email dell'account. Ti invieremo un link per creare una nuova password."}
          </p>
        </div>

        {done ? (
          <div className="rounded-2xl border border-[#EAEAEA] bg-white p-8 text-center">
            <MailCheck className="w-10 h-10 text-[#0055FF] mx-auto" />
            <p className="mt-4 font-medium" data-testid="forgot-success">Email inviata a {email}</p>
            <Link to="/login" className="mt-6 inline-block text-[#0055FF] font-medium" data-testid="forgot-back-login">
              ← Torna al login
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3" data-testid="forgot-form">
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#666]" />
              <Input
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="h-12 pl-11 rounded-2xl border-[#EAEAEA] bg-white"
                data-testid="forgot-email-input"
              />
            </div>
            <button
              type="submit"
              disabled={busy}
              className="w-full h-12 rounded-full bg-[#111] text-white hover:bg-[#333] transition disabled:opacity-60"
              data-testid="forgot-submit"
            >
              {busy ? "Invio in corso…" : "Invia link di reset"}
            </button>
            <Link
              to="/login"
              className="mt-4 inline-flex items-center gap-1 text-sm text-[#666] hover:text-[#111]"
              data-testid="forgot-back-link"
            >
              <ArrowLeft className="w-4 h-4" /> Torna al login
            </Link>
          </form>
        )}
      </motion.div>
    </div>
  );
}
